<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading">Фитнес-возраст</h5>
        <h6>{{ coeff }} лет</h6>
        <h6 class="alert-heading">{{ msg }}</h6>
    </b-alert>
</template>

<script>
import _ from "lodash";

export default {
        props: {
            data: {
                type: Object,
            }
        },
        computed: {
            coeff: function () {
                return this.data.out.sportAge.toFixed(0);
            },
            coeffRate: function () {
                return this.data.out.sportAge - this.data.age;
            },
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 9;
                        },
                        msg: 'Пятая группа',
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 7, 9);
                        },
                        msg: 'Четвёртая группа',
                        variant: 'danger',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 5, 7);
                        },
                        msg: 'Третья группа',
                        variant: 'info',
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 3, 5);
                        },
                        msg: 'Вторая группа',
                        variant: 'warning',
                    },
                    {
                        is: function (x) {
                            return x < 3;
                        },
                        msg: 'Первая группа',
                        variant: 'success',
                    },
                ]
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeffRate);
                });
            }
        }
    }
</script>